import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { Link } from 'dibs-elements/exports/Link.tsx';
import ChevronUp from 'dibs-icons/exports/ChevronUp.ts';
import ChevronDown from 'dibs-icons/exports/ChevronDown.ts';
import ChevronLeft from 'dibs-icons/exports/ChevronLeft.ts';
import ChevronRight from 'dibs-icons/exports/ChevronRight.ts';

import styles from './CarouselArrowButton.scss';

const ICONS = {
    up: ChevronUp,
    down: ChevronDown,
    left: ChevronLeft,
    right: ChevronRight,
} as const;

const ICON_VARIATION = {
    small: '20',
    medium: '20',
    large: '24',
} as const;

export const CarouselArrowButton: FC<{
    direction: keyof typeof ICONS;
    size: keyof typeof ICON_VARIATION;
    onClick: () => void;
    ariaLabel: string;
    dataTn?: string;
    className?: string;
    appearance?: 'frosted' | 'solid';
}> = ({ direction, size, onClick, ariaLabel, dataTn, className, appearance = 'frosted' }) => {
    const Icon = ICONS[direction];
    const isSolid = appearance === 'solid';

    return (
        <Link
            className={classnames(
                dibsCss.absolute,
                dibsCss.zBump,
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter,
                dibsCss.p0,
                dibsCss.roundedFull,
                isSolid ? [dibsCss.textWhite, dibsCss.fillWhite] : dibsCss.textNoir,
                styles[appearance],
                styles[size],
                className
            )}
            onClick={onClick}
            dataTn={dataTn}
            ariaLabel={ariaLabel}
        >
            <Icon variation={ICON_VARIATION[size]} />
        </Link>
    );
};
